import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { getActingRole } from '@/lib/acting';

const AdminHardRedirect: React.FC = () => {
  const { isAdminUser } = useAuth();
  const location = useLocation();

  // If user is admin and on non-admin routes, redirect to admin dashboard
  // BUT: Allow admins to act as other roles
  React.useEffect(() => {
    const actingRole = getActingRole();
    
    // If admin is acting as employer or job_seeker, don't redirect
    if (actingRole === 'employer' || actingRole === 'job_seeker') {
      console.log('[AdminHardRedirect] Admin is acting as:', actingRole, '- allowing navigation');
      return;
    }
    
    if (isAdminUser && !location.pathname.startsWith('/admin')) {
      // Only redirect if not already on admin routes and not acting as another role
      console.log('[AdminHardRedirect] Admin not acting, redirecting to admin dashboard');
      window.location.href = '/admin/dashboard';
    }
  }, [isAdminUser, location.pathname]);

  return null; // This component doesn't render anything
};

export default AdminHardRedirect;
